import { fetchMatch } from '../../../entities/match';
import { updatePlayerMatchMark } from '../../../entities/player';

export const scope = 'MATCH_READ';

export function fetchMatchIfNeeded(payload) {
    return (dispatch, getState) => {
        const reducer = getState().app.onSite.matches.read;

        if (!reducer.info.isFetching)
            dispatch(fetchMatch(payload, scope));
    };
}

export function updateMark(payload) {
    return (dispatch, getState) => {
        const reducer = getState().app.onSite.matches.read;

        if (!reducer.info.isFetching)
            dispatch(updatePlayerMatchMark(payload, scope));
    };
}



// WEBPACK FOOTER //
// ./src/actions/app/onSite/matches/read.js